import {ProductDataStore} from "../../stores/productDataStore";
import {ProductDataService} from "../../services/productDataService";
import {AppStateService} from "../../services/appStateService";
import {UIService} from "../UIService";
import {PvcWindowMullionRule} from "../../services/pvcWindowMullionRule";

export class MullionsService {
    private productDataStore: ProductDataStore;
    private productDataService: ProductDataService;
    private appStateService: AppStateService;
    private uiService: UIService;
    private pvcWindowMullionRule: PvcWindowMullionRule;

    constructor() {
        this.productDataStore = new ProductDataStore();
        this.productDataService = new ProductDataService();
        this.appStateService = new AppStateService();
        this.uiService = new UIService();
        this.pvcWindowMullionRule = new PvcWindowMullionRule();
    }

    public resetSelectedOptions() {
        let mullionId = this.productDataStore.getInitialOptionByName('dividerSize').id;
        let muntinId = this.productDataStore.getInitialOptionByName('mullionSize').id;

        this.productDataService.updateSelectedOptionByName('dividerSize', mullionId);
        this.productDataService.updateSelectedOptionByName('mullionSize', muntinId);
        this.productDataService.removePredefinedMullionsLayout();


        this.productDataStore.setAttributeByName('mullions', {
                'horizontalCount': 0,
                'verticalCount': 0,
                'vertical': [],
                'horizontal': [],
            }
        );

        this.uiService.resetSelectionsByPartName('mullionsPredefinedSetup');
        this.uiService.resetSelectionsByPartName('mullion');
        this.uiService.resetSelectionsByPartName('muntin');

        this.uiService.setSelectedOption(this.uiService.getElementByPartNameAndId('mullion', mullionId));

        const muntinOption = this.uiService.getElementByPartNameAndId('muntin', muntinId);
        if (muntinOption) {
            this.uiService.setSelectedOption(muntinOption);
        }
    }

    public getInsideMuntinColors(insideColorPaletteId:number) {
        let colors = this.productDataStore.getAvailableOptionsByName('color');
        let filteredColors = [];
        colors.forEach((color) => {
            if (color.attributes.paletteIds.indexOf(insideColorPaletteId) > -1) {
                filteredColors.push({
                    name: color.attributes.name,
                    value: color.id,
                    matchedColorId: color.attributes.matched_colour_id,
                });
            }
        });

        return filteredColors;
    }

    public getOutsideMuntinColors(outsideColorPaletteId:number) {
        let colors = this.productDataStore.getAvailableOptionsByName('color');
        let filteredColors = [];
        colors.forEach((color) => {
            if (color.attributes.paletteIds.indexOf(outsideColorPaletteId) > -1) {
                filteredColors.push({
                    name: color.attributes.name,
                    value: color.id,
                    matchedColorId: color.attributes.matched_colour_id,
                });
            }
        });

        return filteredColors;
    }

    public getPredefinedCombinations()
    {
        let predefinedCombinations = this.productDataStore.getAvailableOptionsByName('predefinedMullionLayout');

        if (this.hideMullionOptionOnRule()) {
            predefinedCombinations = predefinedCombinations.filter((combination) => combination.data.mullions.horizontal.length === 0 && combination.data.mullions.vertical.length === 0);
        }

        // if (this.addMullionService.systemAddedDividers.horizontal > 0) { //todo: filter by dividers
        //     return filter(predefinedSetups, (element) => Number(element.data.horizontalDividers) > 0);
        // }

        if (this.productDataService.getCurrentMainSashWidth() < 300) {
            predefinedCombinations = predefinedCombinations.filter((element) => element.attributes.isForSashWidthRestricted);
        }

        return predefinedCombinations;
    }

    public validatePvcWindowMullionRule() {
        if (this.pvcWindowMullionRule.validate(
            this.productDataStore.getAttributeByName('height'),
            this.productDataStore.getProductInfoAttributeByName('productEligibleForPvcMullionRule')
        )) {
            this.appStateService.setAppSettingTemplateFlag('mullions', 'mullionPVCRulePredefinedCombinationsNotice', true);
            this.appStateService.setAppSettingTemplateFlag('mullions', 'mullionPVCRuleCustomSetupNotice', true);
            this.uiService.refreshElementsInModule('mullions');

            return true;
        }

        this.appStateService.setAppSettingTemplateFlag('mullions', 'mullionPVCRulePredefinedCombinationsNotice', false);
        this.appStateService.setAppSettingTemplateFlag('mullions', 'mullionPVCRuleCustomSetupNotice', false);
        this.uiService.refreshElementsInModule('mullions');
        return false;
    }

    public hideMullionOptionOnRule() {
        return this.productDataStore.getProductInfoAttributeByName('productEligibleForMullionRule');
    }
}
